import { useEffect, useRef, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { formatCurrency, parseDisplay } from "../../utils/formatters/CurrencyFormatter";

type CurrencyInputProps = {
    value?: number;
    onChange: (value?: number) => void;
};

export default function CurrencyInput({ value, onChange }: CurrencyInputProps) {
    const [displayValue, setDisplayValue] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    // Solo sincroniza desde fuera cuando no est� enfocado
    useEffect(() => {
        if (!isFocused) {
            setDisplayValue(value !== undefined ? formatCurrency(value) : "");
        }
    }, [value, isFocused]);

   

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const text = e.target.value;
        // Dejar escribir libremente, solo bloquear caracteres no num�ricos
        if (/^[\d.,\s]*$/.test(text) || text === "") {
            setDisplayValue(text);
            // Emitir el n�mero parseado en tiempo real
            const numeric = parseDisplay(text);
            onChange(numeric);
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
        // Mostrar valor sin formato al enfocar
        if (value !== undefined) {
            const raw = Number.isInteger(value)
                ? String(value)
                : String(value).replace(".", ",");
            setDisplayValue(raw);
        }
        setTimeout(() => inputRef.current?.select(), 0);
    };

    const handleBlur = () => {
        setIsFocused(false);
        const numeric = parseDisplay(displayValue);
        if (numeric !== undefined) {
            setDisplayValue(formatCurrency(numeric));
            onChange(numeric);
        } else {
            setDisplayValue("");
            onChange(undefined);
        }
    };

    return (
        <InputGroup>
            <Form.Control
                ref={inputRef}
                type="text"
                inputMode="decimal"
                value={displayValue}
                className="text-end"
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={(e) => e.key === "Enter" && inputRef.current?.blur()}
                placeholder="0,00"
            />
            <InputGroup.Text>&euro;</InputGroup.Text>
        </InputGroup>
    );
}